<template>
  <transition name="modal">
    <div class="overlay-bg product-info-overlay" @click="clickedBackground">
      <div class="overlay" ref="overlay">
        <button
          type="button"
          class="overlay__close-btn"
          @click.stop="$emit('close-info-panel')"
        >
          <span class="overlay__close-btn-text">Close</span>
        </button>

        <h1 class="product-info-overlay__title">{{ title }}</h1>
        <h2 class="product-info-overlay__body">
          <slot name="info"><div v-html="info"/></slot>
        </h2>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ProductInfoOverlay",
  props: {
    title: {
      type: String,
      required: true,
    },
    info: {
      type: String,
      required: false,
    },
  },
  methods: {
    clickedBackground(e) {
      if (!this.$refs.overlay.contains(e.target)) {
        this.$emit("close-info-panel");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.product-info-overlay {
  cursor: default;

  &__title {
    font-weight: $font-medium;

    margin: 0 0 $spacing-small 0;
    text-align: start;

    @include media("<medium") {
      padding-top: 3.5rem;
      text-align: center;
    }
  }

  &__body {
    font-weight: $font-regular;
    text-align: start;
  }
}
</style>
